import { useCallback } from 'react';
import AxiosConfig from '../../../config/AxiosConfig';

const useAttachmentURL = (_attachmentId) => {
  const getAttachmentUrl = useCallback(async (attachmentId) => {
    try {
      const response = await AxiosConfig.create(
        'get',
        `/attachments/${attachmentId}/url`
      )
        .call()
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Failed to get attachment URL:', err);
      return null;
    }
  }, []);

  return {
    getAttachmentUrl,
  };
};

export default useAttachmentURL;
